import React, { useState, useMemo, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import { greatPlaceStyle } from './my_great_place_styles.js';
import img from '../../../../public/assets/img/test-front.png';

const Mape = ({ latitude, longitude, infoTotal, clck, zoom }) => {
  const [zoomzzom, setZoomzzom] = useState(1);

  const zm = zoom;
  const infoTotalinMap = infoTotal;

  const renderMarkers = (map, maps) => {
    const marker = new maps.Marker({
      map,
      title: 'Hello World!',
    });
    return marker;
  };

  function handleClick(text, empresa, email, direccion) {
    clck(text, empresa, email, direccion);
  }

  function funcZooom(asd) {
    return asd;
  }

  const MyGreatPlace = ({ text, empresa, email, direccion }) => (
    <button onClick={() => handleClick(text, empresa, email, direccion)}>
      <div style={greatPlaceStyle}>{text}</div>
    </button>
  );

  useEffect(() => {
    setZoomzzom(zoom);
    funcZooom(zoom);
  }, [zoom, zoomzzom]);

  return (
    <div className='mapaResponsive md:h-full md:w-full '>
      {zoomzzom == 4 ? (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.RAZZLE_GOOGLE_MAPS_API_KEY,
            language: 'es',
            region: 'es',
            libraries: ['places'],
          }}
          center={{ lat: latitude, lng: longitude }}
          onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
          yesIWantToUseGoogleMapApiInternals
          zoom={zoomzzom}
        >
          {infoTotalinMap.map((x) => (
            <MyGreatPlace
              direccion={x.direccion}
              email={x.email}
              icon='https://lh3.googleusercontent.com/bECXZ2YW3j0yIEBVo92ECVqlnlbX9ldYNGrCe0Kr4VGPq-vJ9Xncwvl16uvosukVXPfV=w300'
              key={x.name}
              lat={x.latitud}
              lng={x.longitud}
              //  text={'A'}
              empresa={x.nombre}
            />
          ))}
        </GoogleMapReact>
      ) : zoomzzom == 7 ? (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.RAZZLE_GOOGLE_MAPS_API_KEY,
            language: 'es',
            region: 'es',
            libraries: ['places'],
          }}
          center={{ lat: latitude, lng: longitude }}
          onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
          yesIWantToUseGoogleMapApiInternals
          zoom={zoomzzom}
        >
          {infoTotalinMap.map((x) => (
            <MyGreatPlace
              direccion={x.direccion}
              email={x.email}
              icon='https://lh3.googleusercontent.com/bECXZ2YW3j0yIEBVo92ECVqlnlbX9ldYNGrCe0Kr4VGPq-vJ9Xncwvl16uvosukVXPfV=w300'
              key={x.name}
              lat={x.latitud}
              lng={x.longitud}
              //  text={'A'}
              empresa={x.nombre}
            />
          ))}
        </GoogleMapReact>
      ) : zoomzzom == 10 ? (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.RAZZLE_GOOGLE_MAPS_API_KEY,
            language: 'es',
            region: 'es',
            libraries: ['places'],
          }}
          center={{ lat: latitude, lng: longitude }}
          onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
          yesIWantToUseGoogleMapApiInternals
          zoom={10}
        >
          {infoTotalinMap.map((x) => (
            <MyGreatPlace
              direccion={x.direccion}
              email={x.email}
              key={x.name}
              lat={x.latitud}
              lng={x.longitud}
              //  text={'A'}
              empresa={x.nombre}
            />
          ))}
        </GoogleMapReact>
      ) : (
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '100%',
          }}
        >
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
              border: ' 1px solid #414141',
              borderRadius: '1rem',
              backgroundImage: `url(${img})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Mape;
